module.exports = __webpack_public_path__ + "static/media/horse.93d7f2a1.svg";